import { render, staticRenderFns } from "./PrivateChatModal.vue?vue&type=template&id=65d4ed70&scoped=true&"
import script from "./PrivateChatModal.vue?vue&type=script&lang=js&"
export * from "./PrivateChatModal.vue?vue&type=script&lang=js&"
import style0 from "./PrivateChatModal.vue?vue&type=style&index=0&id=65d4ed70&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d4ed70",
  null
  
)

export default component.exports